import styled from 'styled-components';
import Styles from '@widgets/shared/styles/modal';
export const Wrapper = styled.dialog `
  padding: 0;
  
  .modal__inner {
    padding: 0;
  }
  
  .modal__close {
    z-index: 2;
  }
  
  .modal__title {
    margin-bottom: 0.5rem;
    display: block;
  }
  
  //transform: translate(-50%, -50%);

  @supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
    @media screen and (min-width: 890px) {
      top: -9.7rem;
      left: calc((100vw - (89rem - 2rem)) * -1); // remove size of basket and manually center
    }
  }

  @media screen and (max-width: 889px) {
    top: 0;
    left: 0;
    transform: initial;
  }

  @supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
    @media screen and (max-width: 889px) {
      top: -10.5rem;
      left: -1rem;
      transform: initial;
    }
  }

  @-moz-document url-prefix() {
    @media screen and (max-width: 889px) {
      top: -10.5rem;
      left: -1rem;
      transform: initial;
    }
  }
`;
export const Container = styled.div `
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 35.5rem;
  max-width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  background-color: var(--section-bg-light);
  color: var(--text-dark);
  
  h1, h2, h3, h4, h5, h6 {
    color: var(--heading-dark);
  }
`;
export const Inner = styled(Styles.Inner) `
  padding: 0;
  max-width: 40rem;
  border-radius: var(--border-radius-lg);
  
  ${Styles.Close} {
    z-index: 3;
  }
`;
export const Copy = styled.div `
  margin-bottom: 2rem;
  
  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
    display: block;
    margin-bottom: 1rem;
    color: var(--heading);
  }
  
  p, .p {
    color: #7c7c7c;
  }
  
  ul {
    li {
      color: var(--text);
      font: var(--paragraph-medium-font);

      & + li {
        margin-top: 0.5rem;
      }
    }
  }

  .tag--aero {
    color: var(--heading);
  }
  
  .wysiwyg:not(:has(p)) {
    color: var(--text);
    
    & + .tags {
      margin-top: 2rem;
    }
  }
`;
export const Content = styled.div `
  padding: 3rem;
  overflow: hidden;

  // to match Mireks design as the top margin is different for some reason
  // but not when the form is loaded??
  &:has(${Copy}) {
    padding-top: 2rem;
  }
`;
export const Title = styled.span `
  font: var(--heading-three-font);
  display: block;
  margin-bottom: 3rem;
  color: var(--heading);
`;
export default {
    Wrapper,
    Container,
    Copy,
    Content,
};
